const uuid = require('uuid');
const Crash = require("crash-colliders");
const Hammer = require('hammerjs');
import { uniq, clone, extend, cloneDeep, values } from 'lodash';

function InteractionData(child, point) {
  this.child = child;
  this.point = point;
}
InteractionData.prototype.getLocalPosition = function (parent) {
  return parent.worldTransform.applyInverse(this.point);
}
function HammerInteractionEvent(child, point, base) {
  this.stopped = false;
  this.data = new InteractionData(child, point);
  extend(this,base);
}
HammerInteractionEvent.prototype.preventDefault = function () {
  this.stopped = true;
}
HammerInteractionEvent.prototype.stopPropagation = function () {
  this.stopped = true;
}


function testHit(root, point, lst=[], localPoint=null) {
  //console.log('TH', root);
  if (typeof(root) === 'undefined' || !root || !root.transform || !root.worldTransform) {
    //console.log('exit', root);
    return false
  }
  let hit = false;
  let childHit = false;
  //const point = localPoint || _point;
  const tempPoint = new PIXI.Point();
  root.worldTransform.applyInverse(point, tempPoint);
  //if (root.interactive || root.children.length > 0 ) {
  if (root.interactive || root.children.length > 0 ) {
    //root.localTransform.applyInverse(point, tempPoint);
    //const tempPoint = root.toLocal(point);
    //console.log('check', root);
    if (root.hitArea && root.hitArea.contains(tempPoint.x, tempPoint.y)) {
      hit = true
    } else if (root.containsPoint && root.containsPoint(point)) {
      hit = true;
    } else if (root._mask && root._mask.containsPoint(point)) {
      hit = true;
    }
      var i = 0;
      for (var i = 0; i < root.children.length; i++) {
        var child = root.children[i];
        childHit = testHit(child,point,lst, tempPoint) || childHit;
      }
  } else {
    if (root.hitArea && root.hitArea.contains(tempPoint.x, tempPoint.y)) {
      hit = true
    } else if (root.containsPoint && root.containsPoint(point)) {
      hit = true;
    } else if (root._mask && root._mask.containsPoint(tempPoint)) {
      hit = true;
    }
  }
  if (hit || childHit) {
    //if (root.interactive) {
      lst.push(root);
    //}
  }
  return hit || childHit;
}
PixiHammer.prototype.convertPixiRect = function (inRect) {
  if (inRect.getBounds) {
    inRect = inRect.getBounds();
  }
  const p = this.screenContainer.worldTransform.applyInverse(inRect);
  const rect = new PIXI.Rectangle(
    p.x,
    p.y,
    inRect.width,
    inRect.height
  )
  return {
    x1:rect.x,
    y1:rect.y,
    x2:rect.x + rect.width,
    y2:rect.y + rect.height
  }
}
function boxesIntersect(a, b) {
  const crash = new Crash({
    overlapLimit:0.5/100
  });

  const rect1 = new crash.Box(new crash.Vector(a.x1,a.y1), a.x2-a.x1, a.y2-a.y1); 
  const rect2 = new crash.Box(new crash.Vector(b.x1,b.y1), b.x2-b.x1, b.y2-b.y1); 

  crash.updateAABB(rect1);
  crash.updateAABB(rect2);

  const intersect = crash.test(rect1, rect2);
  if (intersect) {
  }
  return intersect;
}
function testHitRectangle(root, rectangle, lst=[]) {
  if (!root || !root.worldTransform) {
    return false
  }
  let hit = false;
  let childHit = false;
  //const point = localPoint || _point;
  const tempPoint = new PIXI.Point();
  //root.worldTransform.applyInverse(point, tempPoint);
  if (root.interactive || root.children.length > 0 ) {
    //root.localTransform.applyInverse(point, tempPoint);
    //const tempPoint = root.toLocal(point);
    if (root.hitArea && boxesIntersect(rectangle, this.convertPixiRect(root.hitArea))) {
      hit = true;
    } else {
      const r = root.getBounds();
      if (boxesIntersect(rectangle, this.convertPixiRect(r))) {
        hit = true;
      }
    }
    var i = 0;
    for (var i = 0; i < root.children.length; i++) {
      var child = root.children[i];
      childHit = testHitRectangle(child,rectangle,lst) || childHit;
    }
  } else {
    if (root.hitArea && boxesIntersect(rectangle, this.convertPixiRect(root.hitArea))) {
      hit = true;
    } else {
      const r = root.getBounds();
      if (boxesIntersect(rectangle, this.convertPixiRect(r))) {
        hit = true;
      }
    }
  }
  if (hit || childHit) {
    //if (root.interactive) {
      lst.push(root);
    //}
  }
  return hit || childHit;
}


const defaultOptions = {
  enablePan:true,
  enableZoom:false
}
//function PixiHammer(app, canvas, renderer, editobjects, transformContainer, screenContainer, editor, enableZoom=true, options) {
function PixiHammer(ticker, renderer, interactivityNode, pixiApp) {
  const isTouch = false;
  const canvas = pixiApp.view;
  const options = Object.assign({}, defaultOptions);
  this.screenContainer = renderer.screenContainer;
  this.screenContainer = renderer.container;
  this.renderer = renderer;
  this.canvas = canvas;
  this.ticker = ticker;
  this.app = pixiApp;
  this.crash = new Crash({
    overlapLimit:0.5/100
  });
  this.crashColliders = {};
  this.crashColliderContainers = {};
  this.last = {};

  //console.log('creat PH', canvas);
  this.interactivityNode = interactivityNode;
  this.hammer = new Hammer(interactivityNode);
  //this.hammer = new Hammer.Manager(interactivityNode, {
    //touchAction: options.enablePan ? 'none' : 'auto'
  //});
  console.log('pannas!?!@#?!@#?!@#!@#?');
  this.hammer.on('tap press panright panleft', () => {
    console.log('tap');
  });


  interactivityNode.addEventListener('pointerdown', (e) => {
    console.log('PD!!!');
    this.renderer.render();
    // HammerJS is retarded and doesnt store the original
    // point where the pan started, so we store the initial
    // pointer down event here.
    this.lastPointerDownPoint = this.makeRelativePoint(getPointFromEvent(e));
  });
  interactivityNode.addEventListener('pointerup', (e) => {
    console.log('PU!!!');
    this.renderer.render();
    // HammerJS is retarded and doesnt store the original
    // point where the pan started, so we store the initial
    // pointer down event here.
    this.lastPointerDownPoint = this.makeRelativePoint(getPointFromEvent(e));
    this.sendEvent('hammerpressup', this.last['hammerpress'], this.makeRelativePoint(getPointFromEvent(e)), e);
  });

  if (isTouch && options.enablePan) {
    const twopan = new Hammer.Pan({
      event:'twopan',
      pointers:2
    })

    const pinch = new Hammer.Pinch({
      threshold:0.1
    })


    pinch.requireFailure(twopan);
    this.hammer.add([twopan, pinch]);

  } else {
  }

  if (options.enablePan) {
    this.hammer.add( new Hammer.Pan({
      threshold:15,
      pointers:1
    }));

    this.hammer.add(new Hammer.Press({
      time:150
    }));

    this.hammer.add(new Hammer.Tap({
      event:'singletap',
      threshold:14
    }));
    const doubleTap = new Hammer.Tap({
      event: 'doubletap',
      taps: 2
    })
  this.hammer.add(doubleTap);
  } else {
    this.hammer.add(new Hammer.Press({
      time:1,
      threshold:200
    }));
    this.hammer.add(new Hammer.Tap({
      event:'singletap',
      threshold:100
    }));
  }


  this.hammer.on('singletap', this.onTap.bind(this));
  this.hammer.on('press', this.onEvent.bind(this, 'hammerpress'));
  this.hammer.on('pressup', (e) => {

    const p = getPointFromEvent(e);

    const point = this.makeRelativePoint(p);

    this.sendEvent('hammerpressup', this.last['hammerpress'], point, e);

    delete this.last['hammerpress'];
  });

  this.hammer.on('swipe', () => {
    this.renderer.render();
  });
  this.hammer.on('panstart', this.onPanStart.bind(this, 'hammerpan'));
  this.hammer.on("panmove", this.onPanMove.bind(this, 'hammerpan'));
  this.hammer.on('panend', this.onPanEnd.bind(this, 'hammerpan'));

  this.hammer.on('twopanstart', this.onPanStart.bind(this, 'twopan'));
  this.hammer.on("twopanmove", this.onPanMove.bind(this, 'twopan'));
  this.hammer.on('twopanend', this.onPanEnd.bind(this, 'twopan'));

  console.log('interactivityNode', interactivityNode);
  if (options.enableZoom) {

    document.body.addEventListener('touchmove', (e) => {
      console.log('AMP');
      e.preventDefault();
      e.stopPropagation();
    });
    interactivityNode.addEventListener("mousewheel", (e) => {
      console.log('wtf');
      
      this.renderer.render();
      const prevScale = cloneDeep(transformContainer.scale);
      if (e.deltaY > 0) {
        transformContainer.scale.x -= 1;
        transformContainer.scale.y -= 1;
        screenContainer.pivot.x -= 1;
        screenContainer.pivot.y -= 1;

      } else {

        transformContainer.scale.x += 1;
        transformContainer.scale.y += 1;

        //screenContainer.pivot.x -= transformContainer.scale.x/61;
        //screenContainer.pivot.y += transformContainer.scale.y/61;

        //screenContainer.pivot.x -= transformContainer.scale.x/ (61/4);
        //screenContainer.pivot.y += transformContainer.scale.y/ (61/4);

        screenContainer.pivot.x += 1;
        screenContainer.pivot.y += 1;

        //const screenMiddle = {
          //x:screenContainer.pivot.x,
          //y:screenContainer.pivot.y
        //}
      }

      e.preventDefault();
      //this.editobjects.d3Objects.toymat.render('drag');
    })
  }

  interactivityNode.addEventListener('pointerdown', (e) => {
    this.renderer.render();
    // HammerJS is retarded and doesnt store the original
    // point where the pan started, so we store the initial
    // pointer down event here.
    this.lastPointerDownPoint = this.makeRelativePoint(getPointFromEvent(e));
  });
  interactivityNode.addEventListener('pointerup', (e) => {
    this.renderer.render();
    // HammerJS is retarded and doesnt store the original
    // point where the pan started, so we store the initial
    // pointer down event here.
    this.lastPointerDownPoint = this.makeRelativePoint(getPointFromEvent(e));
    this.sendEvent('hammerpressup', this.last['hammerpress'], this.makeRelativePoint(getPointFromEvent(e)), e);
  });


  /*
  this.activeRegion.bind(canvas, customPan, (e) => {
    if (this.enableScroll) {
      return;
    }
    (e.detail.events).forEach( _e => _e.originalEvent.preventDefault());
    (e.detail.events).forEach( _e => _e.originalEvent.stopPropagation());
    e.preventDefault();
    e.stopPropagation();
    this.onPanMove(e);
  }); 

  const r = Math.random();
  this.activeRegion.bind(canvas, 'tap', (e) => {
    //this.editobjects.addDebug('tap');
    //if (isTouch && e.detail.events[0].originalEvent.type == 'mouseup') {
      //return;
    //}
    this.editobjects.addDebug(e.detail.events[0].originalEvent.toString());
    this.onTap(e);
  })
  */



  let pinchStartScale = null;
  let pinchStarted = false;
  if (options.enableZoom) {
    this.hammer.on('pinchstart', () => {
      this.renderer.render();
      pinchStarted = true;
    });
    this.hammer.on('pinchmove', (e) => {
      this.renderer.render();
      if (!pinchStarted) {
        return;
      }
      if (!pinchStartScale) {
        pinchStartScale = transformContainer.scale.x;
      }
      const scale = e.scale;
      transformContainer.scale.x = pinchStartScale * scale;
      transformContainer.scale.y = pinchStartScale * scale;
      this.renderer.render();

    });
    this.hammer.on('pinchend', () => {
      this.renderer.render();
      pinchStartScale = null;
      pinchStarted = false;
    });
    this.hammer.on('pinchcancel', () => {
      this.renderer.render();
      pinchStartScale = null;
      pinchStarted = false;
    });
  }

}

PixiHammer.prototype.updateInteractive = function (container) {
  this.app.ticker.addOnce( () => {
    values(this.crashColliderContainers).forEach( (container) => {
      this.updateInteractiveOne(container);
    });
  });
}

PixiHammer.prototype.updateInteractiveOne = function (container) {
    //container.updateTransform();
    const id = container.__pbcInteractiveUuid;
    let collider = this.crashColliders[id];
    this.crash.remove(collider);

    const a = this.convertPixiRect(container.getBounds());
    collider = new this.crash.Box(new this.crash.Vector(a.x1,a.y1), a.x2-a.x1, a.y2-a.y1); 
    collider.data = {container}
    this.crashColliders[id] = collider;
    this.crashColliderContainers[id] = container;
    this.crash.insert(collider);
   
  
}
PixiHammer.prototype.addInteractive = function (container) {
  console.log('addInteractive');
  if (!container.__pbcInteractiveUuid) {
    container.__pbcInteractiveUuid = uuid.v4()
  }
  this.app.ticker.addOnce( () => {
    console.log('adding interactive');
    if (!container.transform) {
      console.warn('not ready');
      return;
    }
    container.updateTransform();
    const id = container.__pbcInteractiveUuid;
    const a = this.convertPixiRect(container.getBounds());
    console.log('bounds', a);
    const collider = new this.crash.Box(new this.crash.Vector(a.x1,a.y1), a.x2-a.x1, a.y2-a.y1); 
    console.log('adding collider', collider);
    collider.data = {container}
    this.crash.insert(collider);
    this.crashColliders[id] = collider;
    this.crashColliderContainers[id] = container;
  });
}
PixiHammer.prototype.removeInteractive = function (container) {
  if (!container) {
    console.warn('passed null container');
    return;
  }
  const id = container.__pbcInteractiveUuid
  const collider = this.crashColliders[id]
  this.crash.remove(collider);
  delete this.crashColliders[id];
  delete this.crashColliderContainers[id];
}
PixiHammer.prototype.worldToScreen = function (point, root = null) {
  if (!root) {
    root = this.app.renderer._lastObjectRendered;
  }
  return root.toGlobal(point);
}

PixiHammer.prototype.screenToWorld = function (point, root = null) {
  if (!root) {
    root = this.app.renderer._lastObjectRendered;
  }
  return root.toLocal(point);
}
PixiHammer.prototype.isTouch = function () {
  return (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch)
}

PixiHammer.prototype.toggleScroll = function () {
  this.toggleEnableScroll();
}

PixiHammer.prototype.makeRelativePoint = function (p) {
  return p;
  var canvasRect = this.interactivityNode.getBoundingClientRect();
  return {
    x:p.x - canvasRect.left,
    y:p.y - canvasRect.top
  }
}
function normalizeRect(rect) {
  let x1 = rect.x1 < rect.x2 ? rect.x1 : rect.x2;
  let y1 = rect.y1 < rect.y2 ? rect.y1 : rect.y2;
  let x2 = rect.x1 < rect.x2 ? rect.x2 : rect.x1;
  let y2 = rect.y1 < rect.y2 ? rect.y2 : rect.y1
  return {
    x1,y1,x2,y2
  }
}

PixiHammer.prototype.testAllInRectangle = function (rectangle) {
  let root = this.screenContainer;
  let root2 = this.transformContainer;;

  rectangle = normalizeRect(clone(rectangle));
  //const lst = []
  //testHitRectangle(root,rectangle,lst)
  //testHitRectangle(root2,rectangle,lst)


  if (!this.__crashSetup) {
    this.crash.onCollision( (a,b,res,cancel) => {
      let candidate = (a.data && a.data.container) ? a : b
      if (candidate.data && candidate.data.container) {
        this.__hitList.push(candidate.data.container);
      }
    });
    this.__crashSetup = true;
  }
  const collider = new this.crash.Box(new this.crash.Vector(rectangle.x1,rectangle.y1), rectangle.x2-rectangle.x1, rectangle.y2-rectangle.y1); 
  //this.crash.insert(collider);
  this.__hitList = [];
  const t1 = new Date().getTime();
  this.crash.testAll(collider);
  const t2 = new Date().getTime();
  //this.crash.remove(collider);

  return this.__hitList;


  return lst;
}
PixiHammer.prototype.sendEvent = function (eventName, _lst, point, e) {
  let root = this.screenContainer;
  let root2 = this.transformContainer;;

  let lst = [];
  let t1 = new Date().getTime();
  console.log('testHit @', point);
  console.log('check screenContainer');
  testHit(root, point, lst);
  console.log('check transformContainer');
  testHit(root2, point, lst);
  console.log('lst is', lst);
  lst = uniq(lst);
  let t2 = new Date().getTime();


  let stoppedPropogation = false;
  let canditates = [];
  let highestHammerIndex = -999;
  for (var i = 0; i < lst.length; i++) {
    var child = lst[i];
    const hammerInteractionEvent = new HammerInteractionEvent(child, point, e);
    const hasEvent = child.listeners(`${eventName}`, true);
    console.log('check event', eventName, child, hasEvent);
    if (hasEvent) {
      let hammerIndex = child.hammerIndex || -999;
      console.log('hammerIndex', child.hammerIndex, hammerIndex);
      if (highestHammerIndex == hammerIndex) {
        canditates.push(child)
      } else if (highestHammerIndex < hammerIndex) {
        canditates = [child];
        highestHammerIndex = hammerIndex;
      }
    }

  };

  let stopPropagation = false;
  const canditatesLength = canditates.length;
  console.log('canditates', canditates);
  this.eventDisplayObjects = [];
  for (let i = 0; i < canditatesLength; i++) {
    const child = canditates[i];
    if (stopPropagation) {
      break;
    }
    const hammerInteractionEvent = new HammerInteractionEvent(child, point, e);
    if (!child.specialThingy) {
      console.log('emit event1', eventName);
      child.emit(`${eventName}`, hammerInteractionEvent);
      this.eventDisplayObjects.push(child);
      if (hammerInteractionEvent.stopped) {
        stoppedPropogation = true;
      }
    } else {
      console.log('emit event2', eventName);
      child.specialThingy.emit(`${eventName}`, hammerInteractionEvent);
      this.eventDisplayObjects.push(child);
      if (hammerInteractionEvent.stopped) {
        stoppedPropogation = true;
      }
    }
  }

}
PixiHammer.prototype.onEvent = function (eventName, e) {
  console.log('ON EVENT!!!1', eventName);
  if (e.srcEvent.STOP_PIXI_HAMMER) {
    return;
  }

  const tt1 = new Date().getTime();
  //let root = this.app.renderer._lastObjectRendered;
  let root = this.screenContainer;
  let root2 = this.transformContainer;;
  let lst = [];

  const p = getPointFromEvent(e);

  const point = this.makeRelativePoint(p);
  if (eventName === 'hammerpress') {
    this.lastPressPoint = point;
  }
  let t1 = new Date().getTime();
  testHit(root, point, lst);
  testHit(root2, point, lst);
  lst = uniq(lst);
  this.last[eventName] = lst;


  let stoppedPropogation = false;
  let canditates = [];
  let highestHammerIndex = -999;
  for (var i = 0; i < lst.length; i++) {
    var child = lst[i];
    const hammerInteractionEvent = new HammerInteractionEvent(child, point, e);
    if (child.listeners(`${eventName}`, true)) {
      let hammerIndex = child.hammerIndex || -999;
      if (highestHammerIndex == hammerIndex) {
        canditates.push(child)
      } else if (highestHammerIndex < hammerIndex) {
        canditates = [child];
        highestHammerIndex = hammerIndex;
      }
    }

  };
  let stopPropagation = false;
  const canditatesLength = canditates.length;
  this.eventDisplayObjects = [];
  for (let i = 0; i < canditatesLength; i++) {
    const child = canditates[i];
    if (stopPropagation) {
      break;
    }
    const hammerInteractionEvent = new HammerInteractionEvent(child, point, e);
    if (!child.specialThingy) {
      child.emit(`${eventName}`, hammerInteractionEvent);
      this.eventDisplayObjects.push(child);
      if (hammerInteractionEvent.stopped) {
        stoppedPropogation = true;
      }
    } else {
      child.specialThingy.emit(`${eventName}`, hammerInteractionEvent);
      this.eventDisplayObjects.push(child);
      if (hammerInteractionEvent.stopped) {
        stoppedPropogation = true;
      }
    }
  }

}

function getPointFromEvent(e) {
  const bb = e.target.getBoundingClientRect();
  const p = {
    x:(e.center ? e.center.x : e.x)- bb.left,
    y:(e.center ? e.center.y : e.y)- bb.top
  }
  return p;

}
PixiHammer.prototype.onTap = function (e) {
  console.log('ONTAP!!!!!!!');
  if (e.srcEvent.STOP_PIXI_HAMMER) {
    return;
  }

  const tt1 = new Date().getTime();
  //let root = this.app.renderer._lastObjectRendered;
  let root = this.screenContainer;
  let root2 = this.transformContainer;;
  const lst = [];
  const bb = e.target.getBoundingClientRect();
  const p = getPointFromEvent(e);
  //const p = {
    //x:e.changedPointers[0].offsetX,
    //y:e.changedPointers[0].offsetY
  //}

  const point = this.makeRelativePoint(p);
  let t1 = new Date().getTime();
  testHit(root, point, lst);
  testHit(root2, point, lst);

  let stopPropagation = false;
  t1 = new Date().getTime();

  if (this.editor && this.editor.commit) {
    if (!e.srcEvent.shiftKey) {
      this.editor.startSelectionTap();
    }
  }
  let highestHammerIndex = -999;

  const at1 = new Date().getTime();
  for (var i = 0; i < lst.length; i++) {
    var child = lst[i];
    if (stopPropagation) {
      break;
    }
    const hammerInteractionEvent = new HammerInteractionEvent(child, point, e);
    if (child.listeners('hammertap', true)) {
      let hammerIndex = child.hammerIndex || -999;
      if (highestHammerIndex <= hammerIndex) {
        if (!child.specialThingy) {
          child.emit('hammertap', hammerInteractionEvent);
          stopPropagation = hammerInteractionEvent.stopped;
          highestHammerIndex = Math.max(highestHammerIndex, hammerIndex);
        } else {
          child.specialThingy.emit('hammertap', hammerInteractionEvent);
          stopPropagation = hammerInteractionEvent.stopped;
          highestHammerIndex = Math.max(highestHammerIndex, hammerIndex);
        }
      }
      //if (highestHammerIndex <= hammerIndex && child.listeners('hammertap')) {
      //} else {
        //child.emit('click', hammerInteractionEvent);
        //stopPropagation = hammerInteractionEvent.stopped;
        //highestHammerIndex = Math.max(highestHammerIndex, hammerIndex);
      //}
    }

  }
  const at2 = new Date().getTime()

  const tt2 = new Date().getTime();
}

PixiHammer.prototype.onPanDown = function (event, e) {
  this.panDownPoint = getPointFromEvent(e);
}
PixiHammer.prototype.onPanStart = function (event, e) {
  //if (this.last['hammerpress']) {
    //return;
  //}
  //if (this.enableScroll) {
    //return;
  //}

  this.panStarted = true;

  let root = this.app.renderer._lastObjectRendered;
  let lst = [];

  //const p = getPointFromEvent(e);
  //const p = this.panDownPoint;
  //const point = this.makeRelativePoint(p);
  let point = this.lastPointerDownPoint;
  // SAFARI!!!!!!!!!!!!!
  if (!point) {
    point = this.makeRelativePoint(getPointFromEvent(e))
    this.lastPointerDownPoint = point;
  }

  // work around for when user moves pointer while pressing
  //       not releasing press
  this.sendEvent('hammerpressup', this.last['hammerpress'], point, e);
  e.FLOOBIDEE = 'aaaaaaaaaaa';
  // Check the screen overlay
  testHit(this.screenContainer, point, lst);
  // Check the world overlay
  testHit(root, point, lst);
  lst = uniq(lst);


  let stoppedPropogation = false;
  let canditates = [];
  let highestHammerIndex = -999;
  for (var i = 0; i < lst.length; i++) {
    var child = lst[i];
    const hammerInteractionEvent = new HammerInteractionEvent(child, point, e);
    if (child.listeners(`${event}start`, true)) {
      let hammerIndex = child.hammerIndex || -999;
      if (highestHammerIndex == hammerIndex) {
        canditates.push(child)
      } else if (highestHammerIndex < hammerIndex) {
        canditates = [child];
        highestHammerIndex = hammerIndex;
      }
    }

  };

  let stopPropagation = false;
  const canditatesLength = canditates.length;
  this.panDisplayObjects = [];
  for (let i = 0; i < canditatesLength; i++) {
    const child = canditates[i];
    if (stopPropagation) {
      break;
    }
    const hammerInteractionEvent = new HammerInteractionEvent(child, point, e);
    if (!child.specialThingy) {
      child.emit(`${event}start`, hammerInteractionEvent);
      this.panDisplayObjects.push(child);
      if (hammerInteractionEvent.stopped) {
        stoppedPropogation = true;
      }
    } else {
      child.specialThingy.emit(`${event}start`, hammerInteractionEvent);
      this.panDisplayObjects.push(child);
      if (hammerInteractionEvent.stopped) {
        stoppedPropogation = true;
      }
    }
  }


}
PixiHammer.prototype.onPanMove = function (event, e) {
  //if (this.last['hammerpress']) {
    //return;
  //}

  //if (this.enableScroll) {
    //return;
  //}
  if (!this.panStarted) {
    return;
  }

  const p = getPointFromEvent(e);
  const point = this.makeRelativePoint(p);

  //const shittyObject = {
    //deltaX:p.x - this.customPanStart.current.x,
    //deltaY:p.y - this.customPanStart.current.y
  //}
  let root = this.app.renderer._lastObjectRendered;

  let stoppedPropogating = false;
  this.panDisplayObjects.forEach( (child) => {
    if (stoppedPropogating) {
        return;
      }
      const hammerInteractionEvent = new HammerInteractionEvent(child, point, e);
      if (!child.specialThingy) {
        child.emit(`${event}move`, hammerInteractionEvent);
      } else {
        child.specialThingy.emit(`${event}move`, hammerInteractionEvent);
      }
      if (hammerInteractionEvent.stopped) {
        stoppedPropogating = true;
      }
  });
}

PixiHammer.prototype.onPanEnd = function (event, e) {
  delete this.lastPointerDownPoint;
  //if (this.last['hammerpress']) {
    //return;
  //}

  //if (this.enableScroll) {
    //return;
  //}
  if (!this.panStarted) {
    return;
  }
  this.panStarted = false;
  const p = getPointFromEvent(e);
  const point = this.makeRelativePoint(p);
  let root = this.app.renderer._lastObjectRendered;

  let stoppedPropogating = false;
  this.panDisplayObjects.forEach( (child) => {
    if (stoppedPropogating) {
        return;
      }
      const hammerInteractionEvent = new HammerInteractionEvent(child, point, e);
      if (!child.specialThingy) {
        child.emit(`${event}end`, hammerInteractionEvent);
      } else {
        child.specialThingy.emit(`${event}end`, hammerInteractionEvent);
      }
      if (hammerInteractionEvent.stopped) {
        stoppedPropogating = true;
      }
  });
}

export {
  testHit
}
